import {
  Box,
  Button,
  AlertIcon,
  Flex,
  Link,
  Loading,
  Modal,
  Typography,
} from '@iheartjane/reefer';

interface QuickCheckoutModalProps {
  fullyReplaceCart: () => void;
  hasCheckoutError: boolean;
  isCheckingOut: boolean;
  isOpen: boolean;
  onClose: () => void;
  resetCheckoutError: () => void;
}

export const QuickCheckoutModal = ({
  fullyReplaceCart,
  hasCheckoutError,
  isCheckingOut,
  isOpen,
  onClose,
  resetCheckoutError,
}: QuickCheckoutModalProps) => (
  <Modal variant="dialogue" open={isOpen} onRequestClose={onClose} overlayClose>
    <Modal.Content>
      <Flex width="100%" flexDirection="column" alignItems="center">
        {isCheckingOut && (
          <>
            <Box position="relative" mb={24}>
              <Loading color="black" size="lg" />
            </Box>
            <Typography branded variant="header-bold" textAlign="center" mb={8}>
              Hang tight
            </Typography>
            <Typography textAlign="center">
              This may take a few seconds.
            </Typography>
          </>
        )}
        {hasCheckoutError && (
          <>
            <AlertIcon size="xl" color="error" />
            <Typography branded variant="header-bold" textAlign="center" mb={8}>
              There was an error checking out.
            </Typography>
            <Typography textAlign="center" mb={8}>
              Please try again from the checkout page.
            </Typography>
            <Button
              onClick={() => fullyReplaceCart()}
              label="Proceed to checkout"
              full
              variant="secondary"
            />
            <Link onClick={resetCheckoutError}>Back to express checkout</Link>
          </>
        )}
      </Flex>
    </Modal.Content>
  </Modal>
);
